import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	IRequestUpdateEmailPhone,
	IRequestUpdateLimits,
	IResponseUpdateEmailPhone,
	IResponseUpdateLimits,
	IRequestUpdatePreference,
	IResponseUpdatePreference,
	IRequestBloqueoTarjeta,
	IResponseBloqueoTarjeta,
	IRequestActualizarTarjeta,
	IResponseActualizarTarjeta
} from '@pacifico/interfaces/configuration-api.interface';
import {
	IReqChangeImage,
	IReqChangePassword,
	IReqPersonData,
	IRequestReqPassword,
	IrequestValidateAnswers,
	IReqUpdateFastCashConfig,
	IReqUpdatePersonData,
	IResGetPersonData,
	IResponseChangeImage,
	IResponseChangePassword,
	IresponseReqPassword,
	IResponseUpdateFastCashConfig,
	IResponseUpdatePersonData,
	IresponseValidateAnswers
} from '@pacifico/interfaces/configurations-api.interface';
import { Observable } from 'rxjs';
import { IResponse } from '../endpoint-api';
import { EndPointApiService } from '../endpoint-api.service';
import {
	IRequestUpdatePassword,
	IResponseUpdatePassword,
	IRequestUpdatePasswordRecovery
} from '@pacifico/interfaces/configurations-api';

@Injectable({ providedIn: 'root' })
export class ConfigurationsApiService {
	constructor(private _httpClient: HttpClient, private _endPointApiService: EndPointApiService) {}

	bloqueoTarjeta(data: IRequestBloqueoTarjeta): Observable<IResponse<IResponseBloqueoTarjeta>> {
		return this._httpClient.post<IResponse<IResponseBloqueoTarjeta>>(
			this._endPointApiService.CONFIGURATIONS.operationsBloqueoTarjeta,
			data
		);
	}

	updateTarjeta(data: IRequestActualizarTarjeta): Observable<IResponse<IResponseActualizarTarjeta>> {
		return this._httpClient.post<IResponse<IResponseActualizarTarjeta>>(
			this._endPointApiService.CONFIGURATIONS.operationsActualizarTarjeta,
			data
		);
	}

	updateLimits(data: IRequestUpdateLimits): Observable<IResponse<IResponseUpdateLimits>> {
		return this._httpClient.post<IResponse<IResponseUpdateLimits>>(
			this._endPointApiService.CONFIGURATIONS.operationsUpdate,
			data
		);
	}

	answersUser(data: IRequestReqPassword): Observable<IResponse<IresponseReqPassword>> {
		return this._httpClient.post<IResponse<IresponseReqPassword>>(
			this._endPointApiService.CONFIGURATIONS.validateUserPacinet,
			data
		);
	}

	validateAnswersUser(data: IrequestValidateAnswers): Observable<IResponse<IresponseValidateAnswers>> {
		return this._httpClient.post<IResponse<IresponseValidateAnswers>>(
			this._endPointApiService.CONFIGURATIONS.validateUserAnswersPacinet,
			data
		);
	}

	updateEmailPhone(data: IRequestUpdateEmailPhone): Observable<IResponse<IResponseUpdateEmailPhone>> {
		return this._httpClient.post<IResponse<IResponseUpdateEmailPhone>>(
			this._endPointApiService.CONFIGURATIONS.operationsUpdateEmailPhone,
			data
		);
	}

	update2FAPreferences(data: IRequestUpdatePreference): Observable<IResponse<IResponseUpdatePreference>> {
		return this._httpClient.post<IResponse<IResponseUpdatePreference>>(
			this._endPointApiService.CONFIGURATIONS.operationsUpdatePreference,
			data
		);
	}

	updatePassword(data: IRequestUpdatePassword): Observable<IResponse<IResponseUpdatePassword>> {
		return this._httpClient.post<IResponse<IResponseUpdatePassword>>(
			this._endPointApiService.CONFIGURATIONS.updatePassword,
			data
		);
	}

	updatePasswordRecovery(data: IRequestUpdatePasswordRecovery): Observable<IResponse<IResponseUpdatePassword>> {
		return this._httpClient.post<IResponse<IResponseUpdatePassword>>(
			this._endPointApiService.CONFIGURATIONS.updatePasswordRecovery,
			data
		);
	}

	updateImage(data: IReqChangeImage): Observable<IResponse<IResponseChangeImage>> {
		return this._httpClient.post<IResponse<IResponseChangeImage>>(
			this._endPointApiService.CONFIGURATIONS.updateImageProfile,
			data
		);
	}

	getPersonData(data: IReqPersonData): Observable<IResponse<IResGetPersonData>> {
		return this._httpClient.post<IResponse<IResGetPersonData>>(
			this._endPointApiService.CONFIGURATIONS.personData,
			data
		);
	}

	updatePersonData(data: IReqUpdatePersonData): Observable<IResponse<IResponseUpdatePersonData>> {
		return this._httpClient.post<IResponse<IResponseUpdatePersonData>>(
			this._endPointApiService.CONFIGURATIONS.updatePerson,
			data
		);
	}

	changePassword(data: IReqChangePassword): Observable<IResponse<IResponseChangePassword>> {
		return this._httpClient.post<IResponse<IResponseChangePassword>>(
			this._endPointApiService.CONFIGURATIONS.realUpdatePassword,
			data
		);
	}

	updateFastCashConfig(data: IReqUpdateFastCashConfig): Observable<IResponse<IResponseUpdateFastCashConfig>> {
		return this._httpClient.post<IResponse<IResponseUpdateFastCashConfig>>(
			this._endPointApiService.CONFIGURATIONS.updateFastCashConfig,
			data
		);
	}
}
